import React from 'react';

const SortIcon = ({ up, down }) => {
  let classes = ['sort-icon'];
  let iconClasses = ['fas'];

  if (up) {
    classes.push('up');
  } else if (down) {
    classes.push('down');
  }

  if (up) iconClasses.push('fa-sort-up');
  if (down) iconClasses.push('fa-sort-down');

  return (
    <div className={ classes.join(' ') }>
      <i className="fas fa-sort-up"></i>
      <i className="fas fa-sort-down"></i>
    </div>
  );
}

export default SortIcon;


// WEBPACK FOOTER //
// ./src/components/sort-icon/sort-icon.js